/** Standard storefront sizes — S through 5XL */
export const PRODUCT_SIZES = ["S", "M", "L", "XL", "XXL", "3XL", "4XL", "5XL"];

export const DEFAULT_SIZE = "M";

export const defaultProductSize = (sizes) => {
  if (!sizes?.length) return DEFAULT_SIZE;
  if (sizes.includes(DEFAULT_SIZE)) return DEFAULT_SIZE;
  return sizes[0];
};

/** Keep sizes in catalog order when toggling in admin */
export const orderSizes = (selected) =>
  PRODUCT_SIZES.filter((s) => selected.includes(s));
